import { render, staticRenderFns } from "./IndustriesData.vue?vue&type=template&id=3cf9155b"
import script from "./IndustriesData.vue?vue&type=script&lang=js"
export * from "./IndustriesData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports